export const BADGE_SIZES = {
  XL: '40',
  L: '30',
  M: '24',
  S: '18',
  XS: '14',
  XXS: '8'
}
